import React from 'react';
import { Redirect } from 'react-router-dom';
import AppConstants from '../../appConstants';
import authService from '../../services/authServices';

/**
 * FREE MODE: the app is 100% free — there are no paid plans, rose/like packs,
 * checkout, billing or gift-purchase pages. Any of those legacy routes now
 * redirect away so the payment UI is unreachable while the underlying page
 * components stay in the codebase (reversible).
 *
 * Only send signed-in visitors to the logged-in home: /match-queue renders the
 * inner layout, which assumes a user object and throws for anonymous visitors.
 * Everyone else goes to the public home page.
 */
const FreeModeRedirect = () => (
  <Redirect to={authService.getToken() ? AppConstants.routes.afterLogin : AppConstants.routes.home} />
);

export default FreeModeRedirect;
